export enum AuctionRelationshipPermission {
  CAN_BUY = 'Can Buy',
  LIST_VERIFIED = 'List Verified',
  LIST_APPRAISALS = 'List Appraisals',
  LIST_SELF_CAPTURED = 'List Self-Captured',
  OWNER = 'Owner',
}
